import { customAlphabet } from 'nanoid'

export type AnalyticsEventName = 'page_view' | 'book_demo' | 'newsletter_signup'

export interface EventPayload {
  page_title: string
  page_location: string
  page_referrer?: string
  user_data?: Record<string, unknown>
}

/**
 * Triggers an event in Google Tag Manager.
 */
export const triggerGoogleTagManagerEvent = (
  eventName: AnalyticsEventName | string,
  payload: EventPayload,
) => {
  const nanoid = customAlphabet('1234567890abcdef', 16)

  window.dataLayer = window.dataLayer || []
  window.dataLayer.push({
    event: eventName as string,
    event_id: nanoid(),
    ...payload,
  })
}
